import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress, _DistributionChannel } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";


export const DistributionChannel = () => {

    const channel = useDataBean(_DistributionChannel);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        channel.instance.getDistributionChannelCatalog(Account, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "Sin Tercero" + (user.DataBeanProperties.AccountName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const addDistributionChannelByAccount = () => {
        //console.log(entailment.bean);
        channel.instance.addDistributionChannelByAccount(channel.bean.IDAccount).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        channel.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        channel.instance.deleteDistributionChannel(channel.bean.IDDistributionChannel).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        channel.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const veradd = () => {
        setModaladd({ ...modaladd, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDDistributionChannel', visible: true },
        { title: 'Tercero', property: 'Client', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Canales de Distribución">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor label="Tercero" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                        Agregar Canal de Distribución
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={channel.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={channel.bean.Name} onChange={channel.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={channel.bean.Description} onChange={channel.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={addDistributionChannelByAccount}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor label="Tercero" idAccount={channel.bean.IDAccount} onChange={(e) => { channel.setBean({ ...channel.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {channel.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}